module.exports = __webpack_public_path__ + "img/phone.4accf3a3.jpeg";